class PartnerPopup extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.init();
    this.checkForSubmittedForm();
  }

  init() {
    this.triggerButton = document.querySelector('[data-partner-popup-button]');
    if (this.triggerButton) {
      this.triggerButton.addEventListener('click', () => this.openPopup());
    } else {
      console.warn('PartnerPopup: trigger button not found');
    }

    if (this.dialog) {
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          this.closePopup();
        }
      });

      this.dialog.addEventListener('close', () => this.closePopup());
    }
  }

  openPopup() {
    this.dialog?.showModal();
  }

  closePopup() {
    this.dialog?.close();
  }

  checkForSubmittedForm() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('contact_posted') === 'true' && window.location.hash === '#PartnerForm') {
      this.openPopup();
    }
  }
}

customElements.define('partner-popup', PartnerPopup);
